/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/require-default-props */
import React from 'react';
import { Link } from 'react-router-dom';
import { FaSignInAlt } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Nav } from './styled';
import MenuItems from './MenuItems/MenuItems';
import UserInfo from './UserInfo';

export default function Header({ onNavigate, collapsed }) {
   const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
   const user = useSelector((state) => state.auth.user);

   return (
      <Nav $collapsed={collapsed}>

         {/* UserInfo no topo */}
         {isLoggedIn && (
            <div className="nav-top">
               <UserInfo user={user} isLoggedIn={isLoggedIn} collapsed={collapsed} />
            </div>
         )}

         {/* Conteúdo central do menu */}
         <div className="nav-content">
            {isLoggedIn ? (
               <MenuItems onNavigate={onNavigate} collapsed={collapsed} />
            ) : (
               <Link
                  to="/login"
                  title="Login"
                  style={{ marginTop: '24px' }}
                  onClick={() => { if (onNavigate) onNavigate(); }}
               >
                  <FaSignInAlt size={24} />
                  {!collapsed && <p>Fazer login</p>}
               </Link>
            )}
         </div>

      </Nav>
   );
}

Header.propTypes = {
   onNavigate: PropTypes.func,
   collapsed: PropTypes.bool,
};
